module.exports = __webpack_public_path__ + "1b8f56ef6dea221271ff576e0a313a75.png";